if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    static CART_CLOSE_TIMEOUT_DESKTOP = 5000;
    static CART_CLOSE_TIMEOUT_MOBILE = 2500;

    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.ajaxCart = document.querySelector('ajax-cart');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const formData = JSON.parse(serializeForm(this.form))
      const existingItem = await this.getExistingItem(formData.id);
      let isQuantityLimitReached = false;
      if (existingItem) {
        const formQuantity = formData.quantity
        const originalQuantity = existingItem.quantity;
        const minQuantity = Math.min(formQuantity, QUANTITY_MAX - originalQuantity);
        formData.quantity = Math.max(minQuantity, 0);
        if (parseInt(formQuantity) !== parseInt(formData.quantity)) {
          isQuantityLimitReached = true;
        }
      }

      const body = JSON.stringify({
        ...formData,
        sections: this.ajaxCart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.ajaxCart.openCart();
          clearTimeout(this.cartTimeout);
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            this.cartTimeout = setTimeout(() => this.ajaxCart.closeCart(), ProductForm.CART_CLOSE_TIMEOUT_MOBILE);
          }else{
            this.cartTimeout = setTimeout(() => this.ajaxCart.closeCart(), ProductForm.CART_CLOSE_TIMEOUT_DESKTOP);
          }
          this.ajaxCart.renderContents(parsedState);
          this.ajaxCart.updateLiveRegionsByVariantId(parsedState.variant_id, formData.quantity, isQuantityLimitReached);
          if (isQuantityLimitReached) this.updateQuantityLimitMessage();
          else this.hideQuantityLimitMessage();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }

    async getExistingItem(variantId) {
      const res = await fetch(`${routes.cart_url}`, { ...fetchConfig('javascript', 'GET') });
      const data = await res.json();
      return data.items.find(item => parseInt(item.id) === parseInt(variantId));
    }

    updateQuantityLimitMessage() {
      document.querySelector(".product-form__error").classList.add("is-visible");
      const limitMsg = window.cartStrings.quantityError.replace("[quantity]", QUANTITY_MAX);
      document.querySelector(".product-form__error-text").innerHTML = limitMsg;
    }

    hideQuantityLimitMessage() {
      document.querySelector(".product-form__error").classList.remove("is-visible");
    }
  });
}
